module.exports = {
  VERY_HIGH: 'very-high',
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
};
